module.exports = __webpack_public_path__ + "img/27_61.a2207d80.png";